import { CheckBookingPage } from '@/app/pages/booking/cancellation/check-booking';
import { createFileRoute } from '@tanstack/react-router';

import { orderNumberSearchSchema } from '@/features/booking/config/order-number-search-schema';

export const Route = createFileRoute('/booking/cancellation/')({
  component: CheckBookingPage,
  validateSearch: orderNumberSearchSchema,
});
